import { useAppDispatch } from 'redux/hooks';
import type { Result } from '@doda/common/src/interfaces/api/recommendPanel';
import { VisibleAnalytics } from '@doda/common/src/components/Analytics/VisibleAnalytics';
import { RecommendSlider } from 'components/RecommendSlider';
import { RecommendGrid } from 'components/RecommendGrid';
import { measureVisibleRecommend } from '@doda/common/src/logics/analytics';
import { useRecommendSection } from '../hooks/useRecommendSection';
import {
  measureBookmarkRecommendCard,
  measureClickRecommendCard,
} from '../logics/analytics';
import { JobListForRecommend } from '../../JobHistoryList/logics/generateJobListForRecommend/generateJobListForRecommend';

// eslint-disable-next-line consistent-return
export const RecommendSection = () => {
  const dispatch = useAppDispatch();
  const { recommendForList, recommendForSlider } = useRecommendSection();

  if (!recommendForList && !recommendForSlider) return null;

  const handleClickCard = () => {
    if (recommendForList)
      dispatch(
        measureClickRecommendCard({
          recommendType: recommendForList.recommendType,
          effectName: recommendForList.effectName,
        })
      );
    if (recommendForSlider)
      dispatch(
        measureClickRecommendCard({
          recommendType: recommendForSlider.recommendType,
          effectName: recommendForSlider.effectName,
        })
      );
  };

  const handleBookmark = (recommend: Result | JobListForRecommend) => {
    dispatch(measureBookmarkRecommendCard(recommend.itemNo));
  };

  if (recommendForList)
    return (
      <VisibleAnalytics
        onVisible={() =>
          measureVisibleRecommend(
            recommendForList.recommendType,
            recommendForList.results
          )
        }
      >
        <RecommendGrid
          recommendList={recommendForList.results}
          title={recommendForList.title}
          recommendType={recommendForList.recommendType}
          onClickFavorite={handleBookmark}
          onClickSaved={undefined}
          bookmarkListUrl="/dcfront/bookmark/bookmarkList/"
          saveBookmarkRequestBody={{ device: 'PC' }}
          onClickCardDetail={handleClickCard}
          onClickThumbnail={handleClickCard}
        />
      </VisibleAnalytics>
    );

  if (recommendForSlider)
    return (
      <VisibleAnalytics
        onVisible={() =>
          measureVisibleRecommend(
            recommendForSlider.recommendType,
            recommendForSlider.results
          )
        }
      >
        <RecommendSlider
          recommendList={recommendForSlider.results}
          title={recommendForSlider.title}
          recommendType={recommendForSlider.recommendType}
          onClickFavorite={handleBookmark}
          onClickSaved={undefined}
          bookmarkListUrl="/dcfront/bookmark/bookmarkList/"
          saveBookmarkRequestBody={{ device: 'PC' }}
          isSummaryBottom={false}
          onClickCardDetail={handleClickCard}
          onClickThumbnail={handleClickCard}
        />
      </VisibleAnalytics>
    );
};
